
/**
 * 상세 에러 정보
 * @nullable
 */
export type UnauthorizedResponseErrorDetails = { [key: string]: unknown } | null;
